import { FC } from "react";
import Translate from "../Translate/Translate";

const BookAppointmentText: FC<{ isReschedule: boolean }> = ({
  isReschedule
}) =>
  isReschedule ? (
    <Translate msg="action.rescheduleAppointment" />
  ) : (
    <Translate msg="action.bookAppointment" />
  );

export default BookAppointmentText;
